import * as React from 'react';

import { StyledCard, Lesson, LessonInfo } from './LessonSelector.styles';
import englishicon from '../../../assets/images/courseicons/english-icon.png';
import historyicon from '../../../assets/images/courseicons/history-icon.png';
import mathicon from '../../../assets/images/courseicons/math-icon.png';
import scienceicon from '../../../assets/images/courseicons/science-icon.png';
import { MEDIA_BASE_URL } from '../../../config/constants';


interface IProps {
  data?: any;
  selectedCourse?: string,
  completedLessons?: any,
  history?: any,
} 

class LessonSelector extends React.Component<IProps> {
  public state = {};

  constructor(props) {
    super(props);
  }

  public onSelectLesson = (id) => {
    const { data, selectedCourse, history, completedLessons } = this.props;

    console.log('Selected Lesson ', id)
    console.log('Selected Course ', selectedCourse)
    console.log('Completed Lessons ', completedLessons)

    history.push(`/students/datacentre/lessons/${id}`, {
      studentID: data.id,
      // courseID: completedLessons[Number(selectedCourse)].id,
      courseID: Number(selectedCourse)
    });
  }

  public render() {
    const { data, selectedCourse, completedLessons } = this.props;
    console.log('CompletedLessons ', completedLessons)

    if (!selectedCourse) { return null; }

    return (
      <StyledCard
        scrollable={true}
        maxHeight={425}
        scrollJumpSize={135}
        title="Completed Lessons"
        subtitle={
          <h5>
            Choose a
            <span> lesson </span>
            to have a better look at
            <span> your performance</span>
          </h5>
        }
      >
        {completedLessons.map((lesson: any) => {
          return (
            <Lesson key={lesson.id} onClick={this.onSelectLesson.bind(this, lesson.id)}>
              <img src={`${MEDIA_BASE_URL}${lesson.Thumbnail}`} />
              <LessonInfo>
                <h3>{lesson.Title}</h3>
                <p>{lesson.Description}</p>
              </LessonInfo>
            </Lesson>
          );
        })}
      </StyledCard>
    );
  }
}

export default LessonSelector;



// WEBPACK FOOTER //
// ./src/components/DataCentre/LessonSelector/LessonSelector.tsx